import { render, staticRenderFns } from "./WurldCheckbox.vue?vue&type=template&id=877833c4&"
import script from "./WurldCheckbox.vue?vue&type=script&lang=js&"
export * from "./WurldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WurldCheckbox.vue"
export default component.exports